import axios from 'axios';

const deleteUser = id => axios.delete(`users/${id}`);

const setTimezone = params => {
  return axios.put(`users/${params.id}/timezone`, params);
};

export { deleteUser, setTimezone };
